import { render } from "./send_ask.vue?vue&type=template&id=616d77a0&scoped=true"
import script from "./send_ask.vue?vue&type=script&lang=js"
export * from "./send_ask.vue?vue&type=script&lang=js"

import "./send_ask.vue?vue&type=style&index=0&id=616d77a0&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616d77a0"]])

export default __exports__